import React from 'react';
import { TEXT_VARIANTS, Text } from 'components/ui/Typography';
import { bytesToSize } from './helpers';

const HelperText = ({ additionalText, maxSize }) => {
  const maxFileSizeString = bytesToSize(maxSize);

  return (
    <div className="seismic-learning-universal-uploader--helperText">
      <Text
        variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
        component="div"
        data-testid="maxSizeText"
      >
        {t('universal_uploader.max_file_size', {
          max_file_size: maxFileSizeString,
        })}
      </Text>
      {additionalText && (
        <Text
          className="additional-text"
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          component="div"
          data-testid="additionalText"
        >
          {additionalText}
        </Text>
      )}
    </div>
  );
};

export { HelperText };
